
/*
对应 MeshUtils::ExportBin
*/

import * as THREE from 'three';

function Bin1Loader(manager) {
    THREE.Loader.call(this, manager);
    this.materials = null;
}

Bin1Loader.prototype = Object.assign(Object.create(THREE.Loader.prototype), {
    constructor: Bin1Loader,
    parse: function (buffer, onLoad, onError) {
        //console.log('buffer', buffer);
        if (buffer.byteLength === 0) {
            onError();
            return;
        }
        const view = new DataView(buffer);
        let index = 0;
        let positionCount = view.getInt32(index, true);
        //console.log("positionCount", positionCount);
        index += 4;
        let vertices = new Float32Array(buffer, index, positionCount * 3);
        index += positionCount * 3 * 4;
        let indicesCount = view.getInt32(index, true);
        //console.log("indicesCount", indicesCount);
        index += 4;
        let indices = new Uint32Array(buffer, index, indicesCount * 3);

        let geom = new THREE.BufferGeometry();
        geom.addAttribute("position", new THREE.BufferAttribute(vertices, 3));
        geom.setIndex(new THREE.BufferAttribute(indices, 1));
        geom.computeVertexNormals();
		
		onLoad(geom);
    },

    load: function (url, onLoad, onProgress, onError) {
        if (url instanceof ArrayBuffer) {
            this.parse(geom, onLoad, onError);
        } else {
            const scope = this;
            let loader = new THREE.FileLoader(scope.manager);
            loader.setPath(this.path);
            loader.setResponseType('arraybuffer');
            loader.load(url, function (buffer) {
                scope.parse(buffer, onLoad, onError);
            }, onProgress, onError);
        }
    }
});

export default Bin1Loader;



// WEBPACK FOOTER //
// ./src/views/mobilPhoneShell3d/scripts/Bin1Loader.js